import {api} from "./api.service";

export class StreakService {

    static async getStreakData(FromDate = '', toDate= '')
    {
        const params = {}

        if(FromDate){
            params['FromDate'] =  FromDate
        }
        if(toDate){
            params['toDate'] =  toDate
        }

        return api.get("streak" , {params});
    }
}
